import firebase from "firebase";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-3NOvComzHwXwkW1wap9rqf4U25uuwdI",
  authDomain: "cj-dev-bcd00.firebaseapp.com",
  databaseURL: "https://cj-dev-bcd00.firebaseio.com",
  projectId: "cj-dev-bcd00",
  storageBucket: "cj-dev-bcd00.appspot.com",
  messagingSenderId: "702241776462",
  appId: "1:702241776462:web:fce89b4cd7bc4100bbf41f"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
// firebase.analytics();

export default firebaseApp.firestore();
